<template>
  <global-dialog-card
    v-model="dialog"
    :title="$t('select_restaurant')"
    :max-width="1200"
    hide-actions
  >
    <template #title-actions>
      <img
        class="card-img-top"
        width="15%"
        src="https://app.restorani.bitlab.host/gallery/ordera-beli.png"
        alt="Logo"
      />
    </template>

    <p class="text-center">{{ $t("select_restaurant") }}</p>
    <v-row class="align-content-center justify-content-center">
      <div
        class="card text-center"
        style="width: 33%; padding: 10px 5px"
        v-for="res in restaurants"
        :key="res.id"
      >
        <div
          style="
            box-shadow: 0 1px 14px 2px rgba(0, 0, 0, 0.12);
            border-radius: 7px;
            height: 230px;
            position: relative;
          "
        >
          <img
            onerror="javascript:this.src='https://app.restorani.bitlab.host/gallery/no-image-restaurant.jpg'"
            style="cursor: pointer"
            @click="selectRestaurant(res)"
            class="card-img-top"
            width="100%"
            height="75%"
            :src="getRestaurantLogo(res)"
            alt="Logo"
          />
          <div class="card-body">
            <h5 class="card-title">{{ toLatin(res.name) }}</h5>
            <p style="font-size: 11px" class="card-text mb-0">
              <span>{{ toLatin(res.address) }}</span>
            </p>
            <p
              @click="selectRestaurant(res)"
              style="font-size: 11px; cursor: pointer"
              class="card-text mb-0 font-weight-bold"
            >
              <span>{{ toLatin(res.city?.name || "") }}</span>
            </p>
          </div>
        </div>
      </div>
    </v-row>
  </global-dialog-card>
</template>

<script>
import userService from "@/services/user";
import hasSnackbar from "@/mixins/hasSnackbar";
import conf from "@/config";

export default {
  name: "RestaurantSelectionDialog",
  mixins: [hasSnackbar],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    restaurants: {
      type: Array,
      default: () => [],
    },
    newUser: {
      type: Object,
      default: () => ({}),
    },
    userData: {
      type: Object,
      default: () => ({ email: "", password: "" }),
    },
  },
  data() {
    return {
      conf: conf,
      isSelecting: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
    getRestaurantLogo(restaurant) {
      if (restaurant.settings && restaurant.settings.logo) {
        return `${this.conf.apiUrlBase}/gallery/${restaurant.id}/${restaurant.settings.logo}`;
      }
      return "";
    },
    async selectRestaurant(restaurant) {
      if (this.isSelecting) return;

      this.isSelecting = true;

      try {
        const { data } = await userService.chooseRestaurant(
          this.newUser.data.id,
          restaurant.id
        );

        if (data.data) {
          this.$emit("restaurant-selected", {
            restaurant,
            userData: this.userData,
          });
          this.close();
        }
      } catch (error) {
        this.showErrorSnackbar(
          this.$t("error_selecting_restaurant") || "Error selecting restaurant"
        );
        console.error("Error selecting restaurant:", error);
      } finally {
        this.isSelecting = false;
      }
    },
  },
};
</script>
